import React, { Fragment, useEffect, useRef, useState } from 'react';
import { 
    Dialog, DialogContentText, DialogActions, 
    DialogTitle, DialogContent, Button, TextField 
} from '@material-ui/core';

import * as actions from '../../../../store/actions/profileActions';
import { useDispatch, useSelector } from 'react-redux';

const ProfilePrompts = ({ prompts }) => {
    const [open, setOpen] = useState(false);
    const [editOpen, setEditOpen] = useState(false);
    const [isEditing, setIsEditing] = useState(true);
    const [editedPrompt, setEditedPrompt] = useState('');
    const [newPrompt, setNewPrompt] = useState('');
    const [newPromptId, setNewPromptId] = useState('');

    const userProfile = useSelector(state => state.profile.userProfile);
    const dispatch = useDispatch();

    const handleOpen = (type, promptContent, id) => {
        if (type === 'add') {
            setOpen(true);
        }
        else{
            setEditOpen(true);
            setNewPrompt(promptContent);
            setEditedPrompt(promptContent);
            setNewPromptId(id);
        }
    }

    const handleClose = type => {
        if (type === 'add') {
            setOpen(false);
        }
        else{
            setEditOpen(false);
        }
    }

    const handleChange = e => {
        if (editedPrompt !== e.target.value) {
            setNewPrompt(e.target.value);
            setIsEditing(false);
        }
        else {
            setNewPrompt(e.target.value);
            setIsEditing(true);
        }
    }

    const handleConfirm = type => {
        switch(type){
            case 'add':
                var data = { profileId: userProfile.profileId, promptContent: newPrompt };
                dispatch(actions.addProfilePrompts(data))
                    .then(() => {
                        setNewPrompt('');
                        setOpen(false);
                    });
            case 'edit':
                var data = { promptId: newPromptId, profileId: userProfile.profileId, promptContent: newPrompt }
                dispatch(actions.updateProfilePrompt(data))
                    .then(() => {
                        setNewPrompt('');
                        setNewPromptId('');
                        setEditOpen(false);
                    })
            default:
                break;
        }
        
    }

    return (
        <div className="content">
            <Dialog
                open={open}
                onClose={() => handleClose('add')}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description">
                    <DialogTitle id="alert-dialog-title">New Profile Prompt</DialogTitle>
                    <DialogContent>
                        <DialogContentText id="alert-dialog-description">
                            Please profile prompt to give your matches a better understanding
                            of who you are! 
                        </DialogContentText>
                        <TextField 
                            value={newPrompt} 
                            onChange={handleChange}
                            label="Prompt Text" 
                            variant="outlined" 
                            fullWidth={true} 
                            multiline={true} />
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={() => handleClose('add')} color="primary">
                            Cancel
                        </Button>
                        <Button onClick={() => handleConfirm('add')} color="primary">
                            Add
                        </Button>
                    </DialogActions>
            </Dialog>
            <Dialog
                open={editOpen}
                onClose={() => handleClose('edit')}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description">
                    <DialogTitle id="alert-dialog-title">Edit Profile Prompt</DialogTitle>
                    <DialogContent>
                        <DialogContentText id="alert-dialog-description">
                            Please profile prompt to give your matches a better understanding
                            of who you are! 
                        </DialogContentText>
                        <TextField 
                            value={newPrompt} 
                            onChange={handleChange}
                            label="Prompt Text" 
                            variant="outlined" 
                            fullWidth={true} 
                            multiline={true} />
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={() => handleClose('edit')} color="primary">
                            Cancel
                        </Button>
                        <Button disabled={isEditing} onClick={() => handleConfirm('edit')} color="primary">
                            Edit
                        </Button>
                    </DialogActions>
            </Dialog>
            {prompts.length !== 0 ?
                prompts.map((prompt,index) => {
                    return (
                        <button key={index} className="prompt-btn"  onClick={() => handleOpen('edit', prompt.promptContent, prompt.promptId)}>
                            <p style={{fontWeight: 'bold', color: '#000'}}>Send me a message if...</p>
                            <p>{prompt.promptContent}</p>
                        </button>
                    )
                }) : null
            }
            <button className="prompt-btn" onClick={() => handleOpen('add')}>Add Prompt</button>
        </div>
    );
}

export default ProfilePrompts;
